/**
 * The two faces the refreshed designs use.
 *
 * Inter carries the entire interface. The serif is an accent only — pull
 * quotes, mastheads, the occasional editorial flourish — and is deliberately
 * not wired into the theme's typography, so it cannot spread into buttons,
 * labels and body copy by default. Reach for it explicitly where a design
 * calls for it.
 *
 * Both fall back to stacks that exist everywhere, so a blocked or slow font
 * request degrades rather than breaking the layout.
 */

export const UI_FONT_STACK =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const ACCENT_FONT_STACK = "'DM Serif Display', Georgia, 'Times New Roman', Times, serif";
